module.exports = __webpack_public_path__ + "img/pngegg.eae0aca0.png";